// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xr8T","colBig":"styles_colBig__25mr7","colSmall":"styles_colSmall__cex-z"};